export enum EUserRole {
  INVENTURA = 'Inventura',
  ADMIN = 'Admin',
}
